import { setKioskCart } from './actions';
import { getKioskSyncCart, shouldNotifyKioskDevice } from './selectors';
import { createCart, updateCart, serializeOrder } from '../saleFlow/helpers';
import { RESET as RESET_CART } from '../register/order/constants';
import { SUCCESS as VALIDATION_SUCCESS, RESET as RESET_VALIDATED_CART } from '../register/validated/constants';
import { handoffResetKioskCart, handoffUpdateKioskCart } from '../handoff/actions';

export const handleValidationSuccess = async (store) => {
  const state = store.getState();
  if (shouldNotifyKioskDevice(state)) {
    const cartFromStore = getKioskSyncCart(state);
    const cart = cartFromStore
      ? await updateCart(store, cartFromStore.id, serializeOrder(store))
      : await createCart(store, serializeOrder(store));

    store.dispatch(handoffUpdateKioskCart(cart.id));
    store.dispatch(setKioskCart(cart));
  }
};

export const handleCartReset = (store) => {
  if (shouldNotifyKioskDevice(store.getState())) {
    store.dispatch(handoffResetKioskCart());
  }
};

const kioskCartSyncMiddleware = store => next => (action) => {
  next(action);
  switch (action.type) {
    case VALIDATION_SUCCESS: {
      handleValidationSuccess(store);
      break;
    }
    case RESET_VALIDATED_CART:
    case RESET_CART: {
      handleCartReset(store);
      break;
    }
    default:
      break;
  }
};

export default kioskCartSyncMiddleware;
